

// 星号仅作视觉必填提示，避免读屏把它当成字段名称的一部分。
export const FormRequiredMark = (label: React.ReactNode, { required }: { required: boolean }) => (
    <>
        {label}
        {required ? <div aria-hidden="true" style={{ color: '#B86765', fontSize: 20, position: 'absolute', right: 2, top: -5, }}>*</div> : <div />}
    </>
);